<div style="margin-top: 20px" class="panel-footer grid-container-one">
  <mat-progress-bar
    style="width: 80%"
    *ngIf="loading"
    id="loadingbar"
    mode="indeterminate"
  ></mat-progress-bar>
  <div class="container">
    <div class="panel panel-primary">
      <div class="panel-heading" id="accordion"></div>
      <div class="">
        <div style="margin-top: 20px">
          <mat-progress-bar
            style="width: 80%"
            *ngIf="loading"
            id="loadingbar"
            mode="indeterminate"
          ></mat-progress-bar>
          <div style="height: 250px; overflow-y: auto">
            <ul class="chat mt-3">
              <li
                *ngFor="let chat of chats"
                [ngClass]="[
                  chat['rep']['id'] == this.identity.sub ? 'right' : 'left'
                ]"
                class="left clearfix"
              >
                <span
                  class="chat-img"
                  [ngClass]="[
                    chat['rep']['id'] == this.identity.sub
                      ? 'pull-right'
                      : 'pull-left'
                  ]"
                >
                  <img
                    *ngIf="chat['rep']['id'] != this.identity.sub"
                    width="40px"
                    style="border-radius: 50px"
                    src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
                      chat['rep']['name'][0]
                    }}{{ chat['rep']['surname'][0] }}"
                    alt="User Avatar"
                    class="img-circle"
                  />
                  <img
                    *ngIf="chat['rep']['id'] == this.identity.sub"
                    width="40px"
                    style="border-radius: 50px"
                    src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
                      chat['rep']['name'][0]
                    }}{{ chat['rep']['surname'][0] }}"
                    alt="User Avatar"
                    class="img-circle"
                  />
                </span>
                <div class="chat-body clearfix">
                  <div class="header" style="margin-bottom: 5px">
                    <small
                      style="margin-left: -60px; float: left"
                      *ngIf="chat['rep']['id'] == this.identity.sub"
                    >
                      <i
                        style="font-size: 20px; cursor: pointer"
                        class="material-icons"
                        (click)="deleteChat(chat['id'])"
                      >
                        delete
                      </i>
                    </small>
                    <small
                      style="font-size: 0.7rem"
                      *ngIf="chat['rep']['id'] == this.identity.sub"
                      class="text-muted"
                    >
                      <i
                        style="font-size: 13px; margin-right: 5px"
                        class="material-icons"
                        >access_time</i
                      >
                      {{
                        chat["createdAt"]["timestamp"] * 1000 | date : "short"
                      }}
                    </small>
                    <strong
                      [ngClass]="[
                        chat['rep']['id'] == this.identity.sub
                          ? 'pull-right'
                          : ''
                      ]"
                      class="primary-font"
                      >{{ chat["rep"]["name"] }}
                      {{ chat["rep"]["surname"] }}</strong
                    >
                    <small
                      style="font-size: 0.7rem"
                      *ngIf="chat['rep']['id'] != this.identity.sub"
                      class="pull-right text-muted"
                    >
                      <i
                        style="font-size: 13px; margin-right: 5px"
                        class="material-icons"
                        >access_time</i
                      >
                      {{
                        chat["createdAt"]["timestamp"] * 1000 | date : "short"
                      }}</small
                    >
                  </div>
                  <p
                    style="white-space: pre-wrap"
                    [ngClass]="[
                      chat['rep']['id'] == this.identity.sub ? 'text-right' : ''
                    ]"
                  >
                    {{ chat["message"] }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <app-message-input
            style="width: 50%"
            (sendMessage)="sendMessage($event)"
          ></app-message-input>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="panel panel-primary">
  <div class="panel-heading" id="accordion"></div>
  <div class="panel-body" *ngIf="chats.length > 0">
    <ul class="chat">
      <li
        *ngFor="let chat of chats"
        [ngClass]="[
          chat['rep']['id'] == this.identity.sub ? 'right' : 'left'
        ]"
        class="left clearfix"
      >
        <span
          class="chat-img"
          [ngClass]="[
            chat['rep']['id'] == this.identity.sub
              ? 'pull-right'
              : 'pull-left'
          ]"
        >
          <img
            *ngIf="chat['rep']['id'] != this.identity.sub"
            width="40px"
            style="border-radius: 50px"
            src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
              chat['rep']['name'][0]
            }}{{ chat['rep']['surname'][0] }}"
            alt="User Avatar"
            class="img-circle"
          />
          <img
            *ngIf="chat['rep']['id'] == this.identity.sub"
            width="40px"
            style="border-radius: 50px"
            src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{
              chat['rep']['name'][0]
            }}{{ chat['rep']['surname'][0] }}"
            alt="User Avatar"
            class="img-circle"
          />
        </span>
        <div class="chat-body clearfix">
          <div class="header" style="margin-bottom: 5px">
            <small
              style="margin-left: -60px; float: left"
              *ngIf="chat['rep']['id'] == this.identity.sub"
            >
              <i
                style="font-size: 20px; cursor: pointer"
                class="material-icons"
                (click)="deleteChat(chat['id'])"
              >
                delete
              </i>
            </small>
            <small
              style="font-size: 0.7rem"
              *ngIf="chat['rep']['id'] == this.identity.sub"
              class="text-muted"
            >
              <i
                style="font-size: 13px; margin-right: 5px"
                class="material-icons"
                >access_time</i
              >
              {{
                chat["createdAt"]["timestamp"] * 1000 | date : "short"
              }}
            </small>
            <strong
              [ngClass]="[
                chat['rep']['id'] == this.identity.sub
                  ? 'pull-right'
                  : ''
              ]"
              class="primary-font"
              >{{ chat["rep"]["name"] }}
              {{ chat["rep"]["surname"] }}</strong
            >
            <small
              style="font-size: 0.7rem"
              *ngIf="chat['rep']['id'] != this.identity.sub"
              class="pull-right text-muted"
            >
              <i
                style="font-size: 13px; margin-right: 5px"
                class="material-icons"
                >access_time</i
              >
              {{
                chat["createdAt"]["timestamp"] * 1000 | date : "short"
              }}</small
            >
          </div>
          <p
            style="white-space: pre-wrap"
            [ngClass]="[
              chat['rep']['id'] == this.identity.sub
                ? 'text-right'
                : ''
            ]"
          >
            {{ chat["message"] }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</div> -->
